import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Sm10030View from "../../Views/Sales/SM10030";
import Snackbar from "../../Components/Snackbar";

function SM10030(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [inputs, setInputs] = React.useState({
    ItemCd: "",
    CustItemCd: "",
    ItemNm: "",
    ItemUnit: "",
    ItemStd: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [searchDate, setSearchDate] = React.useState(new Date());
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  const [endDate, setEndDate] = React.useState(new Date());
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async (_searchDate) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    if (_searchDate) {
      setSearchDate(_searchDate);
    }

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          setLanData((getLanData = result.filter((f) => f.lanType !== "MENU")));
        }
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Sales.SM10030.GetSalesDelivStatus,
        {
          startDate: new Date(startDate),
          endDate: new Date(endDate),
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            // message: lanData.filter(
            //   (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            // )[0].lanName,
            message: "데이터가 없습니다.",
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            // message: lanData.filter(
            //   (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            // )[0].lanName,
            message: "데이터가 없습니다.",
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              delivOrderNo: data[i].delivOrderNo,
              custCd: data[i].custCd,
              custNm: data[i].custNm,
              address: data[i].address,
              eMail: data[i].eMail,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              itemQty: data[i].itemQty,
              itemStdAmt: data[i].itemStdAmt,
              delivQty: data[i].delivQty,
              delivAmt: data[i].delivQty * data[i].itemStdAmt,
              deliveryCheckDate: data[i].deliveryCheckDate
                ? Commons.DateFormating(data[i].deliveryCheckDate.toString(), 2)
                : "",
              remark: data[i].remark,
              itemAmt: data[i].delivAmt * data[i].delivQty,
              itemVat:
                data[i].itemVatYn === "Y"
                  ? data[i].delivAmt * data[i].delivQty * 0.1
                  : "0",
              totalAmt:
                data[i].itemVatYn === "Y"
                  ? data[i].delivAmt * data[i].delivQty * 1.1
                  : data[i].delivAmt * data[i].delivQty,
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <Sm10030View
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        searchDate={searchDate}
        setSearchDate={setSearchDate}
        Init={Init}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default SM10030;
